
document.addEventListener("DOMContentLoaded", function() {
  const setCookie = (name, value, minutes) => {
    let expires = "";
    if (minutes) {
      const today = new Date();
      today.setTime(today.getTime() + minutes * 60 * 1000);
      expires = `; expires=${today.toLocaleString()}`;
    }
    document.cookie = `${name}=${value}${expires}; path=/`;
  };

  const getCookie = (name) => {
    const searchCookie = `${name}=`;
    const cookieArray = document.cookie.split(";");
    for (let i = 0; i < cookieArray.length; i++) {
      let singleCookie = cookieArray[i];
      while (singleCookie.charAt(0) === " ") {
        singleCookie = singleCookie.substring(1, singleCookie.length);
      }
      if (singleCookie.indexOf(searchCookie) === 0) {
        return singleCookie.substring(searchCookie.length, singleCookie.length);
      }
    }
    return null;
  };

  const startCountdown = (minutes) => {
    let seconds = minutes * 60;
    const timer = document.getElementById("timer");
    const minutesSelector = document.querySelector(".minutes");
    const secondsSelector = document.querySelector(".seconds");

    const countdown = setInterval(function () {
      seconds--;

      // Calculate minutes and seconds
      let mins = Math.floor(seconds / 60);
      let secs = seconds % 60;

      // Add leading zeroes
      mins = mins < 10 ? "0" + mins : mins;
      secs = secs < 10 ? "0" + secs : secs;

      // Display the remaining time in separate divs
      minutesSelector.innerText = `${mins}`;
      secondsSelector.innerText = `${secs}`;
      // Check if countdown is finished
      if (seconds <= 0) {
        clearInterval(countdown);
        minutesSelector.innerText = "00";
        secondsSelector.innerText = "00";
        // Clear the saved countdownTime cookie
        setCookie("countdownTime", "", -1);
      } else {
        // Clear the saved countdownTime cookie
        setCookie("countdownTime", seconds, 15);
      }
    }, 1000);
  };

  // Check if countdown is saved in a cookie
  const savedTime = getCookie("countdownTime");

  if (savedTime !== null) {
    // Continue the countdown from the saved time
    startCountdown(savedTime / 60);
  } else {
    // Start the countdown
    startCountdown(15);
  }

});